import React, { useState, useEffect } from 'react';
import { DraggableModal } from 'src/app/components';
import 'src/app/popup.scss';
import styles from 'src/app/pages/Administration/tabs/EventTab/Event.module.scss';
import OntologyForm from '../OntologiesForm/ontologiesForm';
import { checkPermissionList } from 'src/app/helpers/permissions.helper';
import { PermissionEnum } from 'src/enums/permission.enum';

import { eventService, userService, veritabaniService } from 'src/app/services';
import { useDispatch, useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { eventActions, userActions } from 'src/app/redux/actions';
import { errorLocals } from 'src/locals';
import { EventCreateResultType, EventDataType, EventResultType } from 'src/types/services/events-service.type';
import { statusHelper, storageHelper } from 'src/app/helpers';
import { OntologyEnum } from 'src/enums/ontology.enum';
import moment from 'moment';
import { EventFormType } from './eventForm.config';
import { displayGenericError, displayLoadingMessage, displaySuccessStatusMessage } from 'src/app/helpers/status.helper';
import { VeritabaniResultType } from 'src/types/services/hymotsc/veritabani.type';
import AdvancedDatabaseOptions from '../../Misc/AdvancedDatabaseOptions';
import { OntologyAndFlowOptionType } from '../../ETECubeSection/etecube-section.config';
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';
import { EventTimePreference } from 'src/enums/eventTimePreference.enum';
import { getEnumSelectOptions } from 'src/app/helpers/enum.helper';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
import Button from 'antd/es/button';
import Select from 'antd/es/select';
import Popover from 'antd/es/popover';
import message from 'antd/es/message';
import { findAdminUser, getAdminUsersOfEvent } from 'src/app/pages/RealLifeSupport/utils/rlsm-assigned-to-users.helper';

const EventForm: React.FC<EventFormType> = ({ onClickOpen, setOnClickOpen, setEditModal, eventForm }) => {
  const { t } = useTranslation();

  const defaultEventData: EventDataType = {
    id: '',
    eventId: '',
    eventName: '',
    eventClassification: '',
    eventTypeId: '',
    audience: '',
    timeplanTemplateId: '',
    eventColor: '#000000',
    anchorEventTime: undefined,
    OSEId: '',
    OCEId: '',
    ODE: '',
    direvalId: '',
    organizationTemplate: '',
    ETE3EventObjectives: '',
    anchorEventLocationId: '',
    hymotsDB: undefined,
    settingId: undefined,
    flowOptionSelectedEventId: undefined,
    ontologyOptionSelectedEventId: undefined,
    timePreference: EventTimePreference.Real,
    defaultRlsmAdminUserId: undefined,
  };

  const dispatch = useDispatch();

  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const { settingList } = useSelector((state: reduxRootTypes.RootStateType) => state.settingState);
  const { eventList } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { usersList } = useSelector((state: reduxRootTypes.RootStateType) => state.userListState);

  const [eventDataInForm, setEventDataInForm] = useState<EventDataType>(eventForm || defaultEventData);
  const [modalInEditMode, setModalInEditMode] = useState<boolean>(false);
  const [addOntologyModal, setAddOntologyModal] = useState<boolean>(false);
  const [addOntologyType, setAddOntologyType] = useState<number | undefined>(undefined);
  const [dbVeritabanlari, setDbVeritabanlari] = useState<VeritabaniResultType[]>([]);

  const { ontologies } = useSelector((state: reduxRootTypes.RootStateType) => state.ontologyState);
  const { eventId } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);

  const [form] = Form.useForm();
  let allToSettings: { id: string | undefined; settingName: string | undefined }[] = [];
  const [allToSetting, setAllToSetting] = useState<{ id: string | undefined; settingName: string | undefined }[]>([]);

  const [dbType, setDbType] = useState<'new' | 'replicate'>('new');
  const [flowOption, setFlowOption] = useState<OntologyAndFlowOptionType>(OntologyAndFlowOptionType.DEFAULT);
  const [ontologyOption, setOntologyOption] = useState<OntologyAndFlowOptionType>(OntologyAndFlowOptionType.DEFAULT);

  const [allEvent, setAllEvent] = useState<EventResultType[]>([]);
  const [jemmFile, setJemmFile] = useState<File | null>(null);
  const [efesUsersFile, setEfesUsersFile] = useState<File | null>(null);

  const users = getAdminUsersOfEvent(usersList, eventForm.id || '');

  const getEventData = async () => {
    try {
      const eventsOfUser: EventResultType[] = [];
      eventList.forEach((e) => {
        userState.events.forEach((x) => {
          if (e.id === x.id) {
            eventsOfUser.push(e);
          }
        });
      });

      setAllEvent(eventsOfUser);
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    getEventData();
  }, [eventList]);

  const handleClickOntology = (type: any) => {
    setAddOntologyType(type);
    setAddOntologyModal(true);
    setModalInEditMode(false);
  };

  const onFormChange = (inputLabel: string, value: any) => {
    setEventDataInForm({
      ...eventDataInForm,
      [inputLabel]: value,
    });
  };

  useEffect(() => {
    if (setEditModal === true) {
      settingList.forEach((element) => {
        // if (element.id === eventForm.settingId) {
        allToSettings.push({
          id: settingList.find((setting) => setting.id === element.id)?.id,
          settingName: settingList.find((setting) => setting.id === element.id)?.name,
        });
      });
    } else {
      settingList.map((obj) => allToSettings.push({ id: obj.id, settingName: obj.name }));
    }

    setAllToSetting(allToSettings);
  }, [settingList]);

  useEffect(() => {
    if (usersList.length === 0) {
      const getUserListData = async () => {
        try {
          const userListData = await userService.lookupUsersTable({ blockSpinner: true });
          dispatch(userActions.setListInformation(userListData.data.rows));
        } catch (error) {
          console.log(error);
        }
      };
      getUserListData();
    } else if (users.length > 0) {
      form.setFieldsValue({
        defaultRlsmAdminUserId: findAdminUser(usersList, eventForm.id || '', eventList)?.id,
      });
    }
  }, [usersList, users]);

  const onFormSave = async (ruleData: EventDataType) => {
    if (setEditModal) {
      try {
        const eventUpdateData = await eventService.eventEdit({
          ...eventDataInForm, // @ts-ignore
          settingId: ruleData.settingId ? ruleData.settingId.key : undefined,
          hymotsDB: eventDataInForm?.hymotsDB ? eventDataInForm.hymotsDB : null,
          defaultRlsmAdminUserId: ruleData.defaultRlsmAdminUserId ? ruleData.defaultRlsmAdminUserId : undefined,
        });
        setEventDataInForm(defaultEventData);
        dispatch(eventActions.eventEdited(eventUpdateData.data));
        dispatch(eventActions.eventTimePreferenceChanged(eventUpdateData.data.timePreference));
        if (eventUpdateData.data.id === eventId) {
          dispatch(
            eventActions.eventDataChanged({
              eventName: eventUpdateData.data.eventId,
              eventClassification: eventUpdateData.data.eventClassification,
              hymotsDB: eventUpdateData.data.hymotsDB,
              hlaContent: eventUpdateData.data.HLAContent,
            }),
          );
        }
        displaySuccessStatusMessage(t('success.edited'));
        setOnClickOpen(false);
      } catch (error: any) {
        if (error !== errorLocals.errorHandledError) {
          statusHelper.displayErrorMessage(error.response.data.message);
        }
      }
    } else {
      try {
        let data: EventCreateResultType = {} as EventCreateResultType;

        if (dbType === 'new') {
          if (
            (flowOption === OntologyAndFlowOptionType.FROM_EVENT && !eventDataInForm.flowOptionSelectedEventId) ||
            (ontologyOption === OntologyAndFlowOptionType.FROM_EVENT && !eventDataInForm.ontologyOptionSelectedEventId)
          ) {
            statusHelper.displayErrorMessage(t('administration.event.pleaseSelectADatabaseToImport'));

            return;
          }

          const eventData = await eventService.createEvent({
            ...eventDataInForm,
            id: undefined,
            //@ts-ignore
            settingId: ruleData.settingId?.key || undefined,
            flowOption: {
              type: flowOption,
              fromEventId:
                flowOption === OntologyAndFlowOptionType.FROM_EVENT ? eventDataInForm.flowOptionSelectedEventId : '',
            },
            ontologyOption: {
              type: ontologyOption,
              fromEventId:
                ontologyOption === OntologyAndFlowOptionType.FROM_EVENT
                  ? eventDataInForm.ontologyOptionSelectedEventId
                  : '',
            },
          });

          data = eventData.data;
        } else if (dbType === 'replicate') {
          const eventData = await eventService.replicateEventDatabase({
            ...eventDataInForm, //@ts-ignore
            settingId: ruleData.settingId.key ? ruleData.settingId.key : undefined,
          });
          data = eventData.data;

          const userRoles =
            userState.events.find((e) => e.roles.length > 0 && e.id === eventDataInForm.selectedEventId)?.roles || [];
          dispatch(userActions.addUserEvent({ id: data.id, eventId: data.eventId, roles: userRoles || [] }));
        }

        dispatch(eventActions.eventAdded({ ...data, forbiddenModules: [] }));
        setEventDataInForm(defaultEventData);
        displaySuccessStatusMessage(t('success.added'));
        setOnClickOpen(false);
      } catch (error) {
        if (error !== errorLocals.errorHandledError) {
          // @ts-ignore
          statusHelper.displayErrorMessage(error.response.data.message);
        }
      }
    }
    setModalInEditMode(false);
  };

  const onChangeDB = (value: number | undefined) => {
    if (dbVeritabanlari) {
      if (value) {
        storageHelper.setValueWithKey('veritabaniId', value.toString());
      } else {
        storageHelper.removeKeyPair('veritabaniId');
      }
    }
  };

  useEffect(() => {
    const veritabaniListesi = async () => {
      try {
        const {
          data: { rows: veritabani },
        } = await veritabaniService.veritabaniLookup({ blockSpinner: true });
        setDbVeritabanlari(veritabani);
      } catch (error) {
        const eventData = form.getFieldsValue();

        form.setFieldsValue({
          ...eventData,
          hymotsDB: undefined,
        });
        if (error === errorLocals.errorHandledError) {
          // @ts-ignore
          statusHelper.displayErrorMessage(error);
        }
      }
    };
    veritabaniListesi();
  }, []);

  const onJemmFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0] ?? null;

    setJemmFile(f);
  };

  const onEfesUserFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0] ?? null;

    setEfesUsersFile(f);
  };

  const sendJEMMDataToBackend = async () => {
    if (jemmFile) {
      const fd = new FormData();

      fd.append('file', jemmFile);

      try {
        displayLoadingMessage(t('loading.importing'), 0, 'jemmImport');

        await eventService.sendJEMMDataToBackend(fd);

        displaySuccessStatusMessage(t('success.imported'), undefined, 'jemmImport');
        setOnClickOpen(false);
      } catch (error) {
        displayGenericError(error, 'jemmImport');
      }
    }
  };

  const sendEfesUsersDataToBackend = async () => {
    if (efesUsersFile) {
      const fd = new FormData();

      fd.append('file', efesUsersFile);

      try {
        displayLoadingMessage(t('loading.importing'), 0, 'efesUsersImport');

        await eventService.sendEfesUsersDataToBackend(fd);

        displaySuccessStatusMessage(t('success.imported'), undefined, 'efesUsersImport');
        setOnClickOpen(false);
      } catch (error) {
        displayGenericError(error, 'efesUsersImport');
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      sendJEMMDataToBackend();
    }, 500);
  }, [jemmFile]);

  useEffect(() => {
    setTimeout(() => {
      sendEfesUsersDataToBackend();
    }, 500);
  }, [efesUsersFile]);

  return (
    <>
      {onClickOpen && (
        <DraggableModal
          headerText={setEditModal ? t('administration.event.editEvent') : t('administration.event.addEvent')}
          onClickClose={() => setOnClickOpen(false)}
          style={{ width: '920px', height: '600px' }}
        >
          <Form
            initialValues={{
              ...eventDataInForm,
            }}
            scrollToFirstError={{ behavior: 'smooth' }}
            onFinish={onFormSave}
            form={form}
            id="eventForm"
          >
            <div className="popup-main-container">
              <div className="popup-container">
                <div className="popup-content" style={{ padding: 0, height: 480 }}>
                  <div className={styles.container} style={{ padding: 10, marginRight: 15 }}>
                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('general.eventId')}</span>
                        <Form.Item name="eventId" rules={[{ required: true, message: t('general.required') || '' }]}>
                          <Input
                            className={styles.standard_input}
                            value={eventDataInForm.eventId}
                            onChange={(e) => onFormChange('eventId', e.target.value)}
                          />
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.eventClassification')}</span>
                        <Form.Item name="eventClassification">
                          <Input
                            className={styles.standard_input}
                            value={eventDataInForm.eventClassification}
                            onChange={(e) => onFormChange('eventClassification', e.target.value)}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="popup-input-container">
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.eventName')}</span>
                        <Form.Item name="eventName" rules={[{ required: true, message: t('general.required') || '' }]}>
                          <Input
                            className={styles.standard_input}
                            value={eventDataInForm.eventName}
                            onChange={(e) => onFormChange('eventName', e.target.value)}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.eventType')}</span>
                        <div className={styles.eventAdd}>
                          <Form.Item name="eventTypeId">
                            <Select
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              value={eventDataInForm.eventTypeId}
                              onChange={(e) => onFormChange('eventTypeId', e.toString())}
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Event_Type)
                                .map((option) => (
                                  <Select.Option key={option.id} value={option.id}>
                                    {option.abbreviation}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                          <div className="popup-input-container">
                            <Button
                              className={styles.add_button}
                              disabled={checkPermissionList(PermissionEnum.OntologiesCreate)}
                              onClick={() => handleClickOntology(OntologyEnum.Event_Type)}
                            >
                              {t('general.add')}
                            </Button>
                          </div>
                        </div>
                      </div>

                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.audience')}</span>
                        <Form.Item name="audience">
                          <Input
                            className={styles.standard_input}
                            value={eventDataInForm.audience}
                            onChange={(e) => onFormChange('audience', e.target.value)}
                          />
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.timeplanTemplate')}</span>
                        <div className={styles.eventAdd}>
                          <Form.Item name="timeplanTemplateId">
                            <Select
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              value={eventDataInForm.timeplanTemplateId}
                              onChange={(e) => onFormChange('timeplanTemplateId', e as string)}
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Event_Type)
                                .map((option) => (
                                  <Select.Option key={option.id} value={option.id}>
                                    {option.abbreviation}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                          <div className="popup-input-container">
                            <Button
                              className={styles.add_button}
                              disabled={checkPermissionList(PermissionEnum.OntologiesCreate)}
                              onClick={() => handleClickOntology(OntologyEnum.Plan)}
                            >
                              {t('general.add')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.eventColor')}</span>
                        <Form.Item name="eventColor">
                          <Input
                            type="color"
                            className={styles.standard_input}
                            value={eventDataInForm.eventColor}
                            onChange={(e) => onFormChange('eventColor', e.target.value)}
                          />
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.anchorEventTime')}</span>
                        <Form.Item name="anchorEventTime">
                          <CustomDatePicker
                            style={{ width: '100%', marginTop: '5px' }}
                            defaultValue={
                              eventDataInForm.anchorEventTime ? moment(eventDataInForm.anchorEventTime) : undefined
                            }
                            defaultPickerValue={moment(
                              moment().format('YYYY-MM-DD HH:mm:ss').concat(' - 23:59'),
                              'YYYY-MM-DD HH:mm:ss',
                            )}
                            onChange={(e) => onFormChange('anchorEventTime', e?.toISOString())}
                          />
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.oseId')}</span>
                        <div className={styles.eventAdd}>
                          <Form.Item name="OSEId">
                            <Select
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              value={eventDataInForm.OSEId}
                              onChange={(e) => onFormChange('OSEId', e as string)}
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Organization)
                                .map((option) => (
                                  <Select.Option key={option.id} value={option.id}>
                                    {option.abbreviation}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                          <div className="popup-input-container">
                            <Button
                              className={styles.add_button}
                              disabled={checkPermissionList(PermissionEnum.OntologiesCreate)}
                              onClick={() => handleClickOntology(OntologyEnum.Organization)}
                            >
                              {t('general.add')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.oceId')}</span>
                        <div className={styles.eventAdd}>
                          <Form.Item name="OCEId">
                            <Select
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              value={eventDataInForm.OCEId}
                              onChange={(e) => onFormChange('OCEId', e as string)}
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Organization)
                                .map((option) => (
                                  <Select.Option key={option.id} value={option.id}>
                                    {option.abbreviation}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                          <div className="popup-input-container">
                            <Button
                              className={styles.add_button}
                              disabled={checkPermissionList(PermissionEnum.OntologiesCreate)}
                              onClick={() => handleClickOntology(OntologyEnum.Organization)}
                            >
                              {t('general.add')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.ode')}</span>
                        <div className={styles.eventAdd}>
                          <Form.Item name="ODE">
                            <Select
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              value={eventDataInForm.ODE}
                              onChange={(e) => onFormChange('ODE', e as string)}
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Organization)
                                .map((option) => (
                                  <Select.Option key={option.id} value={option.id}>
                                    {option.abbreviation}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                          <div className="popup-input-container">
                            <Button
                              className={styles.add_button}
                              disabled={checkPermissionList(PermissionEnum.OntologiesCreate)}
                              onClick={() => handleClickOntology(OntologyEnum.Organization)}
                            >
                              {t('general.add')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.direval')}</span>
                        <div className={styles.eventAdd}>
                          <Form.Item name="direvalId">
                            <Select
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              value={eventDataInForm.direvalId}
                              onChange={(e) => onFormChange('direvalId', e as string)}
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Player_Audience_Entity)
                                .map((option) => (
                                  <Select.Option key={option.id} value={option.id}>
                                    {option.abbreviation}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                          <div className="popup-input-container">
                            <Button
                              className={styles.add_button}
                              disabled={checkPermissionList(PermissionEnum.OntologiesCreate)}
                              onClick={() => handleClickOntology(OntologyEnum.Player_Audience_Entity)}
                            >
                              {t('general.add')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.organizationTemplate')}</span>
                        <Form.Item name="organizationTemplate">
                          <Input
                            className={styles.standard_input}
                            value={eventDataInForm.organizationTemplate}
                            onChange={(e) => onFormChange('organizationTemplate', e.target.value)}
                          />
                        </Form.Item>
                      </div>
                      {/* <div className="popup-input-container">
                        <span className="popup-input-title">ETE3 EVENT OBJECTIVES</span>
                        <Form.Item name="ETE3EventObjectives">
                          <Input
                            className={styles.standard_input}
                            value={eventDataInForm.ETE3EventObjectives}
                            onChange={(e) => onFormChange('ETE3EventObjectives', e.target.value)}
                          />
                        </Form.Item>
                      </div> */}
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.anchorEventLocation')}</span>
                        <div className={styles.eventAdd}>
                          <Form.Item name="anchorEventLocationId">
                            <Select
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              value={eventDataInForm.anchorEventLocationId}
                              onChange={(e) => onFormChange('anchorEventLocationId', e as string)}
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Location)
                                .map((option) => (
                                  <Select.Option key={option.id} value={option.id}>
                                    {option.abbreviation}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                          <div className="popup-input-container">
                            <Button
                              className={styles.add_button}
                              disabled={checkPermissionList(PermissionEnum.OntologiesCreate)}
                              onClick={() => handleClickOntology(OntologyEnum.Location)}
                            >
                              {t('general.add')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="popup-input-container" id="hymotsDBSelect">
                        <span className="popup-input-title">{t('administration.event.hymotscDatabase')}</span>
                        <Form.Item name="hymotsDB">
                          <Select
                            id="hymotsDB"
                            showSearch
                            className={styles.select_full}
                            optionFilterProp="children"
                            onChange={(e) => {
                              onFormChange('hymotsDB', e as number);
                              onChangeDB(e);
                            }}
                            allowClear={true}
                            defaultValue={eventDataInForm.hymotsDB ? eventDataInForm.hymotsDB : undefined}
                          >
                            {dbVeritabanlari.map((option) => (
                              <Select.Option key={option.id} value={option.id}>
                                {option.veritabaniIsmi}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span>{t('administration.event.timeReference')}</span>
                            <Popover
                              content={
                                <div style={{ height: 'auto', width: 550 }}>
                                  <div>{t('administration.event.timeReferencePopover.section1')}</div>
                                  <div>{t('administration.event.timeReferencePopover.section2')}</div>
                                </div>
                              }
                              zIndex={9999}
                            >
                              <QuestionCircleOutlined style={{ fontSize: 14, cursor: 'help' }} />
                            </Popover>
                          </div>
                        </span>
                        <Form.Item name="timePreference">
                          <Select
                            getPopupContainer={(trigger) => trigger.parentElement}
                            labelInValue
                            className={styles.select_full}
                            onChange={(e) => onFormChange('timePreference', e.value)}
                          >
                            {getEnumSelectOptions(EventTimePreference).map((o) => (
                              <Select.Option key={o[1]} value={o[1]}>
                                {t(`administration.event.eventTimePreferenceEnum.${o[0]}`)}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.event.settings')}</span>
                        <Form.Item name="settingId">
                          <Select
                            getPopupContainer={(trigger) => trigger.parentElement}
                            labelInValue
                            className={styles.select_full}
                          >
                            {allToSetting.length > 0 &&
                              Object.values(settingList).map((option, idx) => (
                                <Select.Option key={option.id} value={option.id}>
                                  {option.name}
                                </Select.Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    {!setEditModal && (
                      <div className="popup-input-container">
                        <Form.Item name="flowOptions" rules={[{ required: false }]}>
                          <AdvancedDatabaseOptions
                            dbType={dbType}
                            setDbType={setDbType}
                            flowOption={flowOption}
                            setFlowOption={setFlowOption}
                            ontologyOption={ontologyOption}
                            setOntologyOption={setOntologyOption}
                            allEvent={allEvent}
                            onFormChange={onFormChange}
                            inEventForm
                          />
                        </Form.Item>
                      </div>
                    )}
                    {setEditModal && (
                      <div className="popup-row grid-col-2-fixed">
                        <div className="popup-input-container">
                          <span className="popup-input-title">{t('administration.event.defaultRlsmAssignedUser')}</span>
                          <Form.Item name="defaultRlsmAdminUserId" rules={[{ required: false }]}>
                            <Select
                              getPopupContainer={(trigger) => trigger.parentElement}
                              className={styles.select_full}
                              showSearch
                              optionFilterProp="children"
                            >
                              {users.map((user) => (
                                <Select.Option key={user.id} value={user.id}>
                                  {user.userName}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>

                        {/* <Form.Item name="importJEMM">
                          <div className="popup-input-container">
                            <span className="popup-input-title">{t('administration.event.importDataFromJEMM')}</span>
                          </div>
                          <input type="file" accept=".docx" onChange={onJemmFileChange} />
                        </Form.Item>
                        <Form.Item name="importEfesUsers">
                          <div className="popup-input-container">
                            <span className="popup-input-title">IMPORT EFES USERS (.xlsx)</span>
                          </div>
                          <input type="file" accept=".xlsx" onChange={onEfesUserFileChange} />
                        </Form.Item> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="popup-footer" style={{ marginRight: '6%', marginTop: '2%' }}>
                <div>
                  <button className="next-button" type="submit">
                    {t('general.save')}
                  </button>
                  <button className="modal-button" onClick={() => setOnClickOpen(false)} type="button">
                    {t('general.cancel')}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </DraggableModal>
      )}
      {addOntologyModal && (
        <OntologyForm
          setEditModal={modalInEditMode}
          addOntologyType={addOntologyType}
          onClickOpen
          setOnClickOpen={setAddOntologyModal}
        />
      )}
    </>
  );
};

export default EventForm;
